import { render, staticRenderFns } from "./LandTransport.vue?vue&type=template&id=04b9cd7f&"
import script from "./LandTransport.vue?vue&type=script&lang=js&"
export * from "./LandTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports